/** @module gridData */

import * as constant from "./constants";

export const gridSquares = {
  "0_0": {
    gateName: "Porta Errolano",
    occupants: [],
    distanceToExit: 1
  },
  "0_1": {
    buildingName: constant.WHITE,
    buildingCapacity: 1,
    occupants: [],
    offSets: [[44, 35]],
    distanceToExit: 2
  },
  "0_2": {
    occupants: [],
    distanceToExit: 3
  },
  "0_3": {
    occupants: [],
    distanceToExit: 3
  },
  "0_4": {
    buildingName: "Purple 2",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [27, 40],
      [63, 40]
    ],
    distanceToExit: 2
  },
  "0_5": {
    gateName: "Porta Vesuvio",
    occupants: [],
    distanceToExit: 1
  },
  "0_6": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [44, 16],
      [44, 47]
    ],
    distanceToExit: 2
  },
  "0_7": {
    ventName: "Scroll"
  },
  "1_0": {
    buildingName: "Grey 1",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [12, 9],
      [12, 45]
    ],
    distanceToExit: 2
  },
  "1_1": {
    buildingName: "Grey 1",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [32, 46],
      [69, 46]
    ],
    distanceToExit: 3
  },
  "1_2": {
    ventName: "Coin"
  },
  "1_3": {
    buildingName: constant.WHITE,
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [22, 9],
      [56, 9],
      [22, 44]
    ],
    distanceToExit: 4
  },
  "1_4": {
    buildingName: "Purple 2",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [27, 50],
      [64, 50]
    ],
    distanceToExit: 3
  },
  "1_5": {
    occupants: [],
    distanceToExit: 2
  },
  "1_6": {
    occupants: [],
    distanceToExit: 3
  },
  "1_7": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [31, 46],
      [66, 46]
    ],
    distanceToExit: 3
  },
  "1_8": {
    occupants: [],
    distanceToExit: 2
  },
  "1_9": {
    gateName: "Porta Di Nola",
    occupants: [],
    distanceToExit: 1
  },
  "2_0": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [56, 15],
      [56, 48]
    ],
    distanceToExit: 3
  },
  "2_1": {
    occupants: [],
    distanceToExit: 4
  },
  "2_2": {
    buildingName: "Purple 3",
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [39, 26],
      [21, 57],
      [58, 57]
    ],
    distanceToExit: 5
  },
  "2_3": {
    buildingName: "Purple 3",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [26, 57],
      [63, 57]
    ],
    distanceToExit: 5
  },
  "2_4": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [31, 15],
      [31, 47]
    ],
    distanceToExit: 4
  },
  "2_5": {
    buildingName: "Grey 4",
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [49, 25],
      [31, 56],
      [68, 56]
    ],
    distanceToExit: 3
  },
  "2_6": {
    buildingName: "Grey 4",
    buildingCapacity: 4,
    occupants: [],
    offSets: [
      [37, 20],
      [74, 20],
      [37, 56],
      [74, 56]
    ],
    distanceToExit: 4
  },
  "2_7": {
    occupants: [],
    distanceToExit: 4
  },
  "2_8": {
    buildingName: "Purple 5",
    buildingCapacity: 4,
    occupants: [],
    offSets: [
      [37, 40],
      [74, 40],
      [37, 75],
      [74, 75]
    ],
    distanceToExit: 3
  },
  "2_9": {
    occupants: [],
    distanceToExit: 2
  },
  "2_10": {
    ventName: "Urn"
  },
  "3_0": {
    occupants: [],
    distanceToExit: 2
  },
  "3_1": {
    buildingName: constant.WHITE,
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [24, 11],
      [58, 11],
      [24, 45]
    ],
    distanceToExit: 3
  },
  "3_2": {
    buildingName: "Turquoise 6",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [34, 34],
      [68, 37]
    ],
    distanceToExit: 4
  },
  "3_3": {
    buildingName: "Turquoise 6",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [21, 54],
      [58, 53]
    ],
    distanceToExit: 5
  },
  "3_4": {
    ventName: "Pillar"
  },
  "3_5": {
    occupants: [],
    distanceToExit: 4
  },
  "3_6": {
    buildingName: "Grey 8",
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [9, 19],
      [8, 57],
      [40, 38]
    ],
    distanceToExit: 4
  },
  "3_7": {
    buildingName: constant.WHITE,
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [25, 15],
      [58, 15],
      [25, 48]
    ],
    distanceToExit: 5
  },
  "3_8": {
    occupants: [],
    distanceToExit: 4
  },
  "3_9": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [30, 10],
      [30, 42]
    ],
    distanceToExit: 3
  },
  "3_10": {
    buildingName: constant.WHITE,
    buildingCapacity: 1,
    occupants: [],
    offSets: [[41, 29]],
    distanceToExit: 2
  },
  "4_0": {
    gateName: "Porta Marina",
    occupants: [],
    distanceToExit: 1
  },
  "4_1": {
    occupants: [],
    distanceToExit: 2
  },
  "4_2": {
    buildingName: "Turquoise 6",
    buildingCapacity: 1,
    occupants: [],
    offSets: [[53, 68]],
    distanceToExit: 3
  },
  "4_3": {
    buildingName: "Turquoise 6",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [21, 66],
      [58, 66]
    ],
    distanceToExit: 4
  },
  "4_4": {
    occupants: [],
    distanceToExit: 5
  },
  "4_5": {
    buildingName: "Purple 7",
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [51, 38],
      [33, 70],
      [70, 70]
    ],
    distanceToExit: 4
  },
  "4_6": {
    buildingName: "Grey 8",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [37, 39],
      [74, 39]
    ],
    distanceToExit: 3
  },
  "4_7": {
    occupants: [],
    distanceToExit: 4
  },
  "4_8": {
    occupants: [],
    distanceToExit: 3
  },
  "4_9": {
    occupants: [],
    distanceToExit: 2
  },
  "4_10": {
    gateName: "Porta Di Sano",
    occupants: [],
    distanceToExit: 1
  },
  "5_0": {
    occupants: [],
    distanceToExit: 2
  },
  "5_1": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [29, 44],
      [65, 44]
    ],
    distanceToExit: 3
  },
  "5_2": {
    occupants: [],
    distanceToExit: 4
  },
  "5_3": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [28, 16],
      [28, 49]
    ],
    distanceToExit: 5
  },
  "5_4": {
    buildingName: "Turquoise 9",
    buildingNumber: 9,
    buildingCapacity: 4,
    occupants: [],
    offSets: [
      [38, 42],
      [74, 42],
      [38, 78],
      [74, 78]
    ],
    distanceToExit: 4
  },
  "5_5": {
    buildingName: "Brown 10",
    buildingCapacity: 3,
    occupants: [],
    offSets: [
      [49, 15],
      [31, 47],
      [68, 47]
    ],
    distanceToExit: 3
  },
  "5_6": {
    occupants: [],
    distanceToExit: 2
  },
  "5_7": {
    buildingName: constant.WHITE,
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [24, 12],
      [24, 44]
    ],
    distanceToExit: 3
  },
  "5_8": {
    buildingName: "Brown 11",
    buildingCapacity: 1,
    occupants: [],
    offSets: [[42, 13]],
    distanceToExit: 2
  },
  "5_9": {
    occupants: [],
    distanceToExit: 3
  },
  "5_10": {
    buildingName: "Brown 11",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [10, 61],
      [48, 61]
    ],
    distanceToExit: 2
  },
  "6_3": {
    ventName: "Mask"
  },
  "6_4": {
    occupants: [],
    distanceToExit: 3
  },
  "6_5": {
    buildingName: "Brown 10",
    buildingCapacity: 2,
    occupants: [],
    offSets: [
      [21, 50],
      [59, 50]
    ],
    distanceToExit: 2
  },
  "6_6": {
    gateName: "Porta De Stabia",
    occupants: [],
    distanceToExit: 1
  },
  "6_7": {
    occupants: [],
    distanceToExit: 2
  },
  "6_8": {
    buildingName: "Brown 11",
    buildingCapacity: 1,
    gateName: "Porta Nocera",
    occupants: [],
    offSets: [[43, 21]],
    distanceToExit: 1
  },
  "6_9": {
    ventName: "Helmet"
  },
  "6_10": {
    buildingName: "Brown 11",
    buildingCapacity: 1,
    occupants: [],
    offSets: [[32, 8]],
    distanceToExit: 3
  }
};

export const gridByColor = {
  White: [
    "0_1",
    "0_6",
    "1_3",
    "1_7",
    "2_0",
    "2_4",
    "3_1",
    "3_7",
    "3_9",
    "3_10",
    "5_1",
    "5_3",
    "5_7"
  ],
  Grey: ["1_0", "1_1", "2_5", "2_6", "3_6", "4_6"],
  Purple: ["0_4", "1_4", "2_2", "2_3", "2_8", "4_5"],
  Turquoise: ["3_2", "3_3", "4_2", "4_3", "5_4"],
  Brown: ["5_5", "5_8", "5_9", "5_10", "6_5", "6_8", "6_10"]
};

export const voidLavaSquares = [
  "0_8",
  "0_9",
  "0_10",
  "1_10",
  "6_0",
  "6_1",
  "6_2"
];

export const voidRunSquares = [
  "0_8",
  "0_10",
  "1_10",
  "6_0",
  "6_1",
  "6_2",
  "-1_-1",
  "-1_0",
  "-1_1",
  "-1_2",
  "-1_3",
  "-1_4",
  "-1_6",
  "-1_7",
  "-1_8",
  "-1_9",
  "-1_10",
  "1_-1",
  "2_-1",
  "3_-1",
  "5_-1",
  "6_-1",
  "7_-1",
  "7_-1",
  "7_0",
  "7_1",
  "7_2",
  "7_3",
  "7_4",
  "7_5",
  "7_7",
  "7_9",
  "7_10",
  "0_11",
  "1_11",
  "2_11",
  "3_11",
  "5_11",
  "6_11",
  "7_11"
];

export const escapeSquares = [
  "-1_5",
  "0_9",
  "0_-1",
  "4_-1",
  "4_11",
  "7_6",
  "7_8"
];

export const gateSquares = ["0_0", "0_5", "1_9", "4_0", "4_10", "6_6", "6_8"];

export const nextToVentSquares = [
  "0_2",
  "0_6",
  "1_1",
  "1_3",
  "1_7",
  "2_2",
  "2_4",
  "2_9",
  "3_3",
  "3_5",
  "3_10",
  "4_4",
  "5_3",
  "5_9",
  "6_4",
  "6_8",
  "6_10"
];
